import * as React from "react";
import { forwardRef } from "react";
const SvgClose = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 25, height: 24, viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Check Icon/Cross" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M16.6998 7.79999L8.2998 16.2M16.6998 16.2L8.2998 7.79999L16.6998 16.2Z", stroke: "#BDBDBD", strokeWidth: 0.878906, strokeLinecap: "round", strokeLinejoin: "round" })));
const ForwardRef = forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
